import { ElLoading } from 'element-plus'
import { ElMessage } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import { ElNotification } from 'element-plus'
import { JSEncrypt } from "jsencrypt";
import axios from 'axios'
import router from './router'
import store from '@/store/index'
import { tc } from '@/languages'
import html2canvas from 'html2canvas'
import { jsPDF } from "jspdf";

let loading = undefined;

const showLoading = () => {
    loading = ElLoading.service({
        lock: true,
        text: tc('global.Loading'),
        background: 'rgba(0, 0, 0, 0.7)',
    });
};

const closeLoading = () => {
    if (loading != undefined) {
        loading.close();
        loading = undefined;
    }
};

const showConfirm = (title, text, option) => {
    option = {
        ...{
            confirmButtonText: tc('global.Confirm'),
            cancelButtonText: tc('global.Cancel'),
        }, ...option
    };
    return ElMessageBox.confirm(text, title, option);
};

const showAlert = (title, text, option) => {
    return ElMessageBox.alert(text, title, option);
};

const showMessage = (type, msg) => {
    ElMessage({ message: msg, type: type, });
};

const showNotification = (type, title, msg) => {
    ElNotification({ title: title, message: msg, type: type, });
};

const refreshPublicKey = () => {
    let json = localStorage.getItem('PublicKey');
    let obj = JSON.parse(json);

    if (obj === null || obj.validityTime === null || new Date() > obj.validityTime) {
        showLoading();
        getNewKey();
    } else {
        showLoading();
        axios.get('/MainSite/Valid', { params: { context: rsaEncrypt("Hello") } })
            .then(response => {
                if (!response.success) {
                    getNewKey();
                }
            }).catch(() => {
                getNewKey();
            }).then(() => {
                closeLoading();
            });
    }
};

const getNewKey = () => {
    axios.get('/MainSite/RSAKey/Key').then(response => {
        let obj = {};
        obj.key = response.content;
        obj.validityTime = new Date().setMinutes(new Date().getMinutes() + 10);
        localStorage.setItem('PublicKey', JSON.stringify(obj));
    }).then(() => {
        closeLoading();
    });
};

const rsaEncrypt = (text) => {
    let key = JSON.parse(localStorage.getItem('PublicKey')).key
    let jsEncrypt = new JSEncrypt({ default_key_size: 2048 });
    jsEncrypt.setPublicKey(key);
    return jsEncrypt.encrypt(text);
};

const isEmpty = (str) => {
    return str == undefined || str == null || str === '';
};

const filterRouter = () => {
    //let userRole = store.state.userMenu.roles;
    let [...menus] = router.getRoutes();
    return menus.filter(p => {
        // if (p.name && p.meta.root) {
        //     if (p.children.length > 0) {
        //         p.children = p.children.filter(c => c.meta.role == undefined || (c.meta.role & userRole.value) != 0);
        //         return p.children.length > 0;                
        //     }
        //     return p.meta.role == undefined || (p.meta.role & userRole.value) != 0;
        // }
        // return false;
        return p.name && p.meta.root;
    });
};

const getDefaultPermission = () => {
    let permission = [];
    let allmenu = filterRouter();

    allmenu.forEach((val) => {
        let item = {
            name: val.name,
            showSubItem: val.meta.showSubItem,
            enable: val.meta.enable,
            icon: val.meta.icon,
            omPermission:val.meta.omPermission
        };

        if (val.children.length > 0) {
            item.children = [];
            val.children.forEach((child) => {
                item.children.push({
                    name: child.name,
                    permission: JSON.parse(JSON.stringify(child.meta.permission ?? [])),
                    enable: child.meta.enable,
                    hidden: child.meta.hidden,
                    omPermission:child.meta.omPermission,
                    bind:child.meta.bind,
                });
            });
        }
        permission.push(item);
    });

    return permission;
};

const getAllPermission = () => {
    let permission = [];
    let allmenu = filterRouter();

    allmenu.forEach((val) => {
        let item = {
            name: val.name,
            showSubItem: val.meta.showSubItem,
            enable:true,
            icon:val.meta.icon,
            omPermission:val.meta.omPermission
        };

        if (val.children.length > 0) {
            item.children = [];
            val.children.forEach((child) => {
                let [...tempPermission] = JSON.parse(JSON.stringify(child.meta.permission ?? []));
                tempPermission.forEach(p => p.value = true);
                item.children.push({
                    name: child.name,
                    permission: JSON.parse(JSON.stringify(tempPermission)),//.forEach( p => p.value = true),
                    enable: child.meta.enable === undefined ? undefined : true,
                    hidden: child.meta.hidden,
                    omPermission:child.meta.omPermission,
                    bind: child.meta.bind,
                });
            });
        }

        permission.push(item);
    });

    return permission;
};

const getUserAdminPermission = () =>{
    let permission = [];
    let allmenu = filterRouter();

    allmenu.forEach((val) => {       
        if(val.meta.omPermission)
            return;
        let item = {
            name: val.name,
            showSubItem: val.meta.showSubItem,
            enable:true,
            icon:val.meta.icon,
            omPermission:val.meta.omPermission
        };

        if (val.children.length > 0) {
            item.children = [];
            val.children.forEach((child) => {
                let [...tempPermission] = JSON.parse(JSON.stringify(child.meta.permission ?? []));
                tempPermission.forEach(p => p.value = true);
                if(!child.meta.omPermission){
                    item.children.push({
                        name: child.name,
                        permission: JSON.parse(JSON.stringify(tempPermission)),//.forEach( p => p.value = true),
                        enable: child.meta.enable === undefined ? undefined : true,
                        hidden: child.meta.hidden,
                        omPermission:child.meta.omPermission,
                        bind: child.meta.bind,
                    });
                }
            });
        }

        permission.push(item);
    });

    return permission;
};

const mergePermission = (permission) => {
    let defaut = JSON.parse(JSON.stringify(getDefaultPermission()));
    defaut.forEach((defaultItem) => {
        let permissionItem = permission.find(p => p.name === defaultItem.name);
        if (permissionItem) {
            if (defaultItem.enable !== undefined) {
                defaultItem.enable = permissionItem.enable;
            }
            defaultItem.children.forEach(defaultChild => {
                let permissionChild = permissionItem.children.find(c => c.name == defaultChild.name);
                if (permissionChild) {
                    if (!defaultItem.showSubItem) {
                        defaultChild.enable = defaultItem.enable;
                    }
                    else if (defaultChild.enable !== undefined) {
                        defaultChild.enable = permissionChild.enable;
                    }

                    defaultChild.permission.forEach(defaultPermission => {
                        let tempPermission = permissionChild.permission.find(p => p.key == defaultPermission.key);
                        if (tempPermission) {
                            defaultPermission.value = tempPermission.value;
                        }
                    });
                }
            });
        }
    });
    return defaut;
};

const refreshPermission = (userInfo) => new Promise((resolve) => {
    axios.get('/DBHub/UserInfo')
        .then(response => {
            if (response.success) {
                response.content.expiration = new Date().getTime() + (30 * 60 * 1000);
                localStorage.setItem('User', JSON.stringify(response.content));
                store.dispatch('setUser', response.content);
            }
            axios.get('/DBHub/Permission/Detail', { params: { role: userInfo.role, groupId: userInfo.dBHubPermission } })
                .then(response => {
                    if (response.success) {
                        store.dispatch('setPermission', mergePermission(response.content.permission));
                    }
                    else {
                        if (userInfo.role == 63)
                            store.dispatch('setPermission', getUserAdminPermission());
                        else if (userInfo.role >= 127)
                            store.dispatch('setPermission', getAllPermission());
                        else
                            store.dispatch('setPermission', getDefaultPermission());
                    }
                    resolve();
                });
        });
});

const initPermission = (refresh) => new Promise((resolve) => {
    let userMenu = store.state.userMenu;

    if(refresh){
        refreshJWT();
    }

    if (refresh || !store.state.userMenu.permission) {
        if (store.state.userMenu.role >= 127) {
            store.dispatch('setPermission', getAllPermission());
            resolve();
        }
        else if (store.state.userMenu.role == 63) {
            store.dispatch('setPermission', getUserAdminPermission());
            resolve();
        }
        else {
            refreshPermission(userMenu).then(() => {
                resolve();
            });
        }
    }
    else {
        resolve();
    }
});

const refreshJWT = () => {
    axios.get('/MainSite/Login/JWT')
        .then(response => {
            if (response.success) {
                localStorage.setItem("JWT", response.content);
            }
        });
};

const checkMenu = (menu) => {
    if (store.state.userMenu.permission) {
        let [...content] = store.state.userMenu.permission;
        for (let i = 0; i < menu.length; i++) {
            if (i === 0) {
                content = content.find(p => p.name === menu[i].name);
                if (!content) return false;
                if (!content.showSubItem)
                    break;
                else if (content.children.filter(c => !c.hidden && c.enable).length == 0)
                    return false;
            }
            else {
                content = content.children.find(p => p.name === menu[i].name && !p.hidden);
            }

            if (!content)
                return false;
        }
        return content.enable;
    }

    return false;
};

//校验路由权限
const checkRoutePermission = (route) => {
    let [...content] = store.state.userMenu.permission;
    for (let i = 0; i < route.length; i++) {
        if (i === 0) {
            content = content.find(p => p.name === route[i].name);
            if (!content.showSubItem)
                break;
        }
        else {
            content = content.children.find(p => p.name === route[i].name);            
        }

        if (!content)
            return false;
    }

    if (content.enable === undefined && content.bind && content.bind.length > 0) {
        for (let i = 0; i < content.bind.length; i++) {
            return checkPagePermission(content.bind[i]);
        }
    }
    return content.enable;
};

const checkPagePermission = (point) => {
    let path = point.split('.');
    let [...menuPath] = router.currentRoute.value.matched;
    let [...permission] = store.state.userMenu.permission;
    let content = {};

    if (path.length == 1) {
        for (let i = 0; i < menuPath.length; i++) {
            if (i === 0) {
                content = permission.find(p => p.name == menuPath[i].name);
            } else {
                content = content.children.find(p => p.name == menuPath[i].name);
            }

            if (!content || !content.enable) {
                return false;
            }
        }

        if (content.permission && content.permission.length > 0) {
            content = content.permission.find(p => p.key === point);
            if (content) {
                return content.value;
            }
        }
    }
    else if (path.length > 1) {
        for (let i = 0; i < path.length - 1; i++) {
            if (i === 0) {
                content = permission.find(p => p.name == path[i]);
            }
            else {
                content = content.children.find(p => p.name == path[i]);
            }

            if (!content || !content.enable) {
                return false;
            }
        }

        if (content.permission && content.permission.length > 0) {
            content = content.permission.find(p => p.key === path[path.length - 1]);
            if (content) {
                return content.value;
            }
        }
    }

    return false;
};

const defaultDateRange = () => {
    return [
        {
            text: tc("global.LastWeek"),
            value: () => {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                return [start, end]
            },
        },
        {
            text: tc("global.LastMonth"),
            value: () => {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                return [start, end]
            },
        },
        {
            text: tc("global.Last3Month"),
            value: () => {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                return [start, end]
            },
        },
    ];
};

const getPicture = (element, callback) => {
    html2canvas(element,{
        allowTaint:true,
        useCORS:true,
        width:element.scrollWeight,
        height:element.scrollHeight
    }).then((canvas) => {
        callback(canvas);
    });
};

const savePDF = (title,canvas) =>{
    let pageData = canvas.toDataURL('image/png',1);
    const pdf = new jsPDF({
        unit: "mm", // 单位，本示例为mm
        format: "a4", // 页面大小
        orientation: "portrait", // 页面方向，portrait: 纵向，landscape: 横向
        putOnlyUsedFonts: true, // 只包含使用的字体
        compress: true, // 压缩文档
        precision: 16, // 浮点数的精度
    });

    // 定义页面边距
    const PAGE_MARGIN = 10;
    // 页面宽高
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();
    const pdfCentWidth = width - PAGE_MARGIN * 2;
    const pdfCentHeight = height - PAGE_MARGIN * 2;
    const widthRatio = pdfCentWidth / canvas.width;
    const heightRatio = pdfCentHeight / canvas.height;
    const ratio = Math.min(widthRatio, heightRatio);
    // 得到图片宽高
    const w = canvas.width * ratio;
    const h = canvas.height * ratio;
    pdf.addImage(pageData, 'JPEG', PAGE_MARGIN,PAGE_MARGIN ,w,h);
    pdf.save(title + '.pdf');
};

const canvasToPDFBlob = (title, canvas) => {
    return new Promise((resolve) => {
        let pageData = canvas.toDataURL('image/png', 1);
        const pdf = new jsPDF({
            unit: "mm",
            format: "a4",
            orientation: "portrait",
            putOnlyUsedFonts: true,
            compress: true,
            precision: 16,
        });

        const PAGE_MARGIN = 10;
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        const pdfCentWidth = width - PAGE_MARGIN * 2;
        const pdfCentHeight = height - PAGE_MARGIN * 2;
        const widthRatio = pdfCentWidth / canvas.width;
        const heightRatio = pdfCentHeight / canvas.height;
        const ratio = Math.min(widthRatio, heightRatio);
        const w = canvas.width * ratio;
        const h = canvas.height * ratio;
        pdf.addImage(pageData, 'JPEG', PAGE_MARGIN, PAGE_MARGIN, w, h);
        
        const blob = pdf.output('blob');
        resolve(blob);
    });
};

const debounce =(fn,time) =>{
    let timer;
    return (...args) => {            
        if(timer){
            clearTimeout(timer);
        }        
        timer = setTimeout(() => {
            fn.apply(this,args);
        }, time);
    }
}

export const arrayGroupBy = (array, callback) => {    
    return array.reduce((acc, item) => {
        let type = callback(item);
        let exists = acc.find( i => i.key === type);
        
        if (exists) {
            exists.items.push(item);
        } else {
            acc.push({
                key :type,
                items:[item]
            });
        }
        return acc;
    }, []);
}

export const saveBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const dataFormatTool = (date,expression = 'YY-MM-DD') => {
    let tempDate = new Date(date);
    let year = tempDate.getFullYear();
    let month = (tempDate.getMonth() + 1).toString().padStart(2,'0');
    let day = tempDate.getDate().toString().padStart(2,'0');
    let hours = tempDate.getHours().toString().padStart(2,'0');
    let minutes = tempDate.getMinutes().toString().padStart(2,'0');
    let seconds = tempDate.getSeconds().toString().padStart(2,'0');

    return expression.replace('YY',year).replace('MM',month).replace('DD',day).replace('hh',hours).replace('mm',minutes).replace('ss',seconds);
}

export {
    showLoading, closeLoading, showMessage, showConfirm, showAlert, showNotification,debounce,
    refreshPublicKey, rsaEncrypt,isEmpty,initPermission,filterRouter,
    checkMenu,
    checkRoutePermission,checkPagePermission,defaultDateRange,
    getPicture,savePDF,canvasToPDFBlob,getDefaultPermission, mergePermission   
}